'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.BAOCart = BAOCart;

var _pushCartActions = require('../../store/actions/push-cart-actions');

var pushCartActions = _interopRequireWildcard(_pushCartActions);

var _functional = require('../../utils/functional');

var _errors = require('./errors');

var _utils = require('./utils');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }newObj.default = obj;return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var dispatch = window.store.dispatch;

function BAOCart() {
  this.store = window.store;

  this.setupAddToCartForms('.js-AddToCart');

  return this;
}

/**
 * This adds items to the cart via the store
 *
 * @param {Number} [id] - This is the id of the products variant
 * @param {String} [handle] - The handle of the product you want to add
 * @param {Object} [properties] - Any line items properties
 * @param {Number} [quantity=1] - The amount of the product
 */
BAOCart.prototype.addItemToCart = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      properties: {},
      quantity: 1
    },
        id = _ref2.id,
        handle = _ref2.handle,
        properties = _ref2.properties,
        quantity = _ref2.quantity;

    var item, data, numberOfVariants, _ref3, addedMoreThanExists, allowedQuantity, alreadyInCart, productName, newItem, _newItem;

    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            item = { id: id, properties: properties, quantity: quantity };

            if (!(id === undefined && handle === undefined)) {
              _context.next = 3;
              break;
            }

            throw new Error('id or handle is required');

          case 3:
            if (!(id === undefined && handle !== undefined)) {
              _context.next = 11;
              break;
            }

            _context.next = 6;
            return (0, _functional.fetchProductData)(handle);

          case 6:
            data = _context.sent;
            numberOfVariants = data.variants.length;

            if (!(numberOfVariants > 1)) {
              _context.next = 10;
              break;
            }

            throw new Error('The handle property can only be used if there is only 1 variant. ' + data.title + ' has ' + numberOfVariants + ' variants');

          case 10:

            item = (0, _assign2.default)({}, item, {
              id: data.variants[0].id
            });

          case 11:
            _context.prev = 11;
            _context.next = 14;
            return this.store.dispatch(pushCartActions.addItemToCart(item));

          case 14:
            _context.next = 40;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context['catch'](11);
            _context.next = 20;
            return (0, _utils.handleAddItemToCartError)(_context.t0);

          case 20:
            _ref3 = _context.sent;
            addedMoreThanExists = _ref3.addedMoreThanExists;
            allowedQuantity = _ref3.allowedQuantity;
            alreadyInCart = _ref3.alreadyInCart;
            productName = _ref3.productName;

            if (!alreadyInCart) {
              _context.next = 29;
              break;
            }

            dispatch(pushCartActions.addError((0, _errors.ALREADY_HAVE_ALL_STOCK_ERROR)(productName)));
            _context.next = 40;
            break;

          case 29:
            if (!addedMoreThanExists) {
              _context.next = 36;
              break;
            }

            newItem = (0, _assign2.default)({}, item, {
              quantity: allowedQuantity
            });
            _context.next = 33;
            return this.store.dispatch(pushCartActions.addItemToCart(newItem));

          case 33:

            dispatch(pushCartActions.addError((0, _errors.NOT_ENOUGH_IN_STOCK_ERROR)(productName)));
            _context.next = 40;
            break;

          case 36:
            _newItem = (0, _assign2.default)({}, item, {
              quantity: allowedQuantity
            });
            _context.next = 39;
            return this.store.dispatch(pushCartActions.addItemToCart(_newItem));

          case 39:

            dispatch(pushCartActions.addError((0, _errors.ADD_TOO_MANY_ERROR)(item.quantity, allowedQuantity, productName)));

          case 40:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[11, 16]]);
  }));

  function addItemToCart() {
    return _ref.apply(this, arguments);
  }

  return addItemToCart;
}();

/**
 * This takes over the submit of all forms on the site so that products get added
 * to the cart via AJAX
 *
 * @param {String} formClass - The CSS class of the product form we want to AJAXify
 */
BAOCart.prototype.setupAddToCartForms = function setupAddToCartForms(formClass) {
  var _this = this;

  document.body.addEventListener('submit', function () {
    var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(e) {
      var form, formData, id, quantity, properties, item;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              form = e.target;

              if (!form.matches(formClass)) {
                _context2.next = 13;
                break;
              }

              e.preventDefault();

              formData = new FormData(form);
              id = Number(formData.get('id'));
              quantity = Number(formData.get('quantity'));
              properties = (0, _utils.buildProperties)(formData);

              _this.store.dispatch(pushCartActions.setItemBeingAddedId(id));

              window.drawers.activeDrawerKey = 'cart';

              item = { id: id, properties: properties, quantity: quantity };
              _context2.next = 12;
              return _this.addItemToCart(item);

            case 12:

              _this.store.dispatch(pushCartActions.setItemBeingAddedId(null));

            case 13:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }());
};